/**
 * Storedash Archive Title Widget
 *
 * Updates the product count when Storedash filters are applied or cleared.
 *
 * Performance design:
 * - Zero extra AJAX requests. The count is read from the `storedash:filters:changed`
 *   event that the filter/clear-filters widgets already dispatch with `totalProducts`.
 * - Only runs when the widget is present on the page.
 * - All DOM updates are O(1) text assignments — no layout thrash.
 */
(function () {
    'use strict';

    var WRAPPER_SEL = '.storedash-archive-title-wrapper[data-show-count="1"]';
    var COUNT_SEL   = '.storedash-archive-title__count';

    /**
     * Dim the count while a filter request is in flight.
     * The CSS transition handles the animation smoothly.
     */
    document.addEventListener('storedash:filters:loading', function () {
        document.querySelectorAll(WRAPPER_SEL).forEach(function (wrapper) {
            var countEl = wrapper.querySelector(COUNT_SEL);
            if (countEl) {
                countEl.classList.add('is-loading');
            }
        });
    });

    /**
     * Update count when filter results arrive.
     * `event.detail.totalProducts` is always the correct value:
     *   - No filters active  → total products in the current category context
     *   - Filters active     → filtered result count
     *   - Filters cleared    → back to the category total (restored from data-initial-count)
     *
     * When filters are cleared, we restore data-initial-count (the PHP-rendered value) rather
     * than trusting totalProducts from the AJAX response. The PHP endpoint uses
     * get_objects_in_term() which does not filter by post_status or WooCommerce catalog
     * visibility, so it can return inflated counts vs the WooCommerce-maintained term->count
     * that was used for the initial render.
     */
    document.addEventListener('storedash:filters:changed', function (event) {
        var detail        = event && event.detail ? event.detail : {};
        var totalProducts = typeof detail.totalProducts !== 'undefined' ? detail.totalProducts : null;
        var isCleared     = detail.cleared === true;

        document.querySelectorAll(WRAPPER_SEL).forEach(function (wrapper) {
            var countEl = wrapper.querySelector(COUNT_SEL);
            if (!countEl) return;

            countEl.classList.remove('is-loading');

            if (isCleared) {
                // Restore the initial PHP-rendered count. This is always correct because it
                // uses WooCommerce's maintained term->count (published, catalog-visible products
                // only), whereas the AJAX total_products uses get_objects_in_term() which
                // includes drafts and other non-visible statuses.
                var initialCount = wrapper.getAttribute('data-initial-count');
                if (initialCount !== null) {
                    countEl.textContent = '(' + initialCount + ')';
                    return;
                }
            }

            if (totalProducts !== null) {
                countEl.textContent = '(' + totalProducts + ')';
            }
        });
    });

}());
